import { render, staticRenderFns } from "./InvoicesPage.vue?vue&type=template&id=d3cb8da0&scoped=true&"
import script from "./InvoicesPage.vue?vue&type=script&lang=js&"
export * from "./InvoicesPage.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesPage.vue?vue&type=style&index=0&id=d3cb8da0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3cb8da0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
